import { NonEmptyArray } from '@/lib/types/helpers';

export function isNonEmptyArray<T>(arr: T[]): arr is NonEmptyArray<T> {
  return arr.length > 0;
}

export function isEmptyArray<T>(arr: T[]): arr is [] {
  return arr.length === 0;
}
